import { useChat } from '~/hooks/useChat';

export const ChatProvider = ({}) => {
  useChat();
  return null;
};
